export default "__VITE_ASSET__BYYE4Zad__"